import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import CustomCarousel from '../../CustomCarousel';
import { Settings } from './settings';
import routes from '../../../../routes';
import {
  Body,
  BtnWrapper,
  CarouselWrapper,
  Cover,
  Date,
  Overlay,
  Title,
} from './style';
import { Container } from '../../../gridSystem';
import { CTA, Text } from '../../../atoms';
import { isPublicPath } from '../../../../utils/common';

const NewsCarousel = ({ data, title }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isPublic = () => isPublicPath(pathname);

  const onClickNews = (id) => {
    if (isPublic()) navigate(`${routes.publicNewsDetails.path}/${id}`);
    else navigate(`${routes.newsDetails.path}/${id}`);
  };

  return data?.length > 0 ? (
    <CarouselWrapper>
      <CustomCarousel config={Settings}>
        {(data || []).map((item) => (
          <Cover src={item?.cover} key={`news-${item?.id}`}>
            <Overlay>
              <Container>
                {item?.publication_from && (
                  <Date>
                    {dayjs(item.publication_from * 1000).format('DD/MM/YYYY')}
                  </Date>
                )}
                <Title>
                  <Text type="h1">
                    {item.title}
                  </Text>
                </Title>
                <Body>
                  <Text type="b4">{item.subtitle}</Text>
                </Body>
                <BtnWrapper>
                  <CTA
                    btnText="scopri di più"
                    onClick={() => onClickNews(item?.id)}
                  />
                </BtnWrapper>
              </Container>
            </Overlay>
          </Cover>
        ))}
      </CustomCarousel>
    </CarouselWrapper>
  ) : null;
};

NewsCarousel.propTypes = {
  data: PropTypes.array,
  title: PropTypes.string,
};

export default NewsCarousel;
